import {Component, Inject} from '@angular/core';

import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import { MaterialModule } from "src/app/app.materials";


/**
 * @title Dialog elements
 */
@Component({
  selector: 'dialog-optimization',
  templateUrl: 'dialog-optimization.html',
  imports: [MaterialModule],
  standalone: true,
})
export class DialogNotifications {
  constructor(
    public dialogRef: MatDialogRef<DialogNotifications>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
